// Define SQL example queries
export const SQL_EXAMPLES = {
  RECENT_EVENTS: {
    name: 'Recent Events',
    query:
      'SELECT *\n' +
      'FROM events\n' +
      'ORDER BY timestamp DESC\n' +
      'LIMIT 10;',
  },
  ACTIVE_USERS: {
    name: 'Most Active Wallets',
    query:
      'SELECT address, COUNT(*) AS event_count\n' +
      'FROM events\n' +
      "WHERE address != ''\n" +
      'GROUP BY address\n' +
      'ORDER BY event_count DESC\n' +
      'LIMIT 10;',
  },
  TOP_BROWSERS: {
    name: 'Top Browsers',
    query:
      'SELECT browser, COUNT(*) AS session_count\n' +
      'FROM sessions\n' +
      'GROUP BY browser\n' +
      'ORDER BY session_count DESC;',
  },
  TOP_DEVICES: {
    name: 'Top Devices',
    query:
      'SELECT device, COUNT(*) AS session_count\n' +
      'FROM sessions\n' +
      'GROUP BY device\n' +
      'ORDER BY session_count DESC;',
  },
  SESSIONS_BY_LOCATION: {
    name: 'Top Countries',
    query:
      'SELECT location, COUNT(*) AS session_count\n' +
      'FROM sessions\n' +
      'GROUP BY location\n' +
      'ORDER BY session_count DESC;',
  },
  AVERAGE_SESSION_LENGTH: {
    name: 'Average Session Length',
    query:
      'SELECT AVG(latest_hit - first_hit) AS avg_session_length\n' +
      'FROM sessions;',
  },
  AVERAGE_DAU: {
    name: 'Average Daily Active Users',
    query:
      'SELECT AVG(daily_users) AS average_dau\n' +
      'FROM (\n' +
      '  SELECT DATE(first_seen) AS date, COUNT(DISTINCT address) AS daily_users\n' +
      '  FROM users\n' +
      '  GROUP BY DATE(first_seen)\n' +
      ') AS daily_counts;',
  },
  DAILY_ACTIVE_USERS: {
    name: 'Daily Active Users Per Day',
    query:
      'SELECT DATE(first_seen) AS date, COUNT(DISTINCT address) AS daily_active_users\n' +
      'FROM users\n' +
      'GROUP BY DATE(first_seen)\n' +
      'ORDER BY date DESC;',
  },
  REVENUE_BY_UTM_CAMPAIGN: {
    name: 'Revenue by UTM Campaign',
    query:
      'SELECT utm_campaign, SUM(revenue) AS total_revenue\n' +
      'FROM revenue\n' +
      'GROUP BY utm_campaign\n' +
      'ORDER BY total_revenue DESC;',
  },
  EVENT_COUNTS_BY_TYPE: {
    name: 'Top Events by Type',
    query:
      'SELECT type, COUNT(*) AS event_count\n' +
      'FROM events\n' +
      'GROUP BY type\n' +
      'ORDER BY event_count DESC;',
  },
};
